export const indicatorsExecutedvsProjectedTooltip = () => {
  return (
    <>
      <div className="HContainer align-center">
        <div
          className="color-indicator"
          style={{
            backgroundColor: "#BBF7D0",
            marginRight: "4px"
          }}
        />
        <p className="create-label-mini">
          <span className="blue-font b">67–100% </span>: Cumplimiento
          satisfactorio o total.
        </p>
      </div>
      <div className="HContainer align-center">
        <div
          className="color-indicator"
          style={{
            backgroundColor: "#FED7AA",
            marginRight: "4px"
          }}
        />
        <p className="create-label-mini">
          <span className="blue-font b">34–66%</span> : Parcialmente cumplido
        </p>
      </div>
      <div className="HContainer align-center">
        <div
          className="color-indicator"
          style={{
            backgroundColor: "#FECDD3",
            marginRight: "4px"
          }}
        />
        <p className="create-label-mini">
          <span className="blue-font b">Menos de 33% </span>: Por debajo del
          objetivo
        </p>
      </div>
    </>
  );
};

export const indicatorOfUnexecutedTasksTooltip = () => {
  return (
    <>
      <div className="HContainer align-center">
        <div
          className="color-indicator"
          style={{
            backgroundColor: "#BBF7D0",
            marginRight: "4px"
          }}
        />
        <p className="create-label-mini">
          <span className="blue-font b">Menos de 33% </span>: Cumplimiento
          satisfactorio o total.
        </p>
      </div>
      <div className="HContainer align-center">
        <div
          className="color-indicator"
          style={{
            backgroundColor: "#FED7AA",
            marginRight: "4px"
          }}
        />
        <p className="create-label-mini">
          <span className="blue-font b">34–66%</span> : Parcialmente cumplido
        </p>
      </div>
      <div className="HContainer align-center">
        <div
          className="color-indicator"
          style={{
            backgroundColor: "#FECDD3",
            marginRight: "4px"
          }}
        />
        <p className="create-label-mini">
          <span className="blue-font b">67–100%</span>: Por debajo del objetivo
        </p>
      </div>
    </>
  );
};

export const classificationTasksTooltip = (classification) => {
  const items = {
    A: (
      <div className="HContainer align-center">
        <p className="create-label-mini">
          <span className="blue-font b">A</span>: Algo muy importante que debe
          hacer, o en caso contrario afrontará graves consecuencias.
        </p>
      </div>
    ),
    B: (
      <div className="HContainer align-center">
        <p className="create-label-mini">
          <span className="blue-font b">B</span>: Actividad que se debería de
          hacer, pero sus consecuencias son leves.
        </p>
      </div>
    ),
    C: (
      <div className="HContainer align-center">
        <p className="create-label-mini">
          <span className="blue-font b">C</span>: Algo que sería agradable hacer,
          pero cuyas consecuencias son inexistentes lo haga o no lo haga.
        </p>
      </div>
    ),
    D: (
      <div className="HContainer align-center">
        <p className="create-label-mini">
          <span className="blue-font b">D</span>: Algo que puede delegar en otra
          persona. Se debe delegar todo lo que puede hacer otro para así contar
          con más tiempo para las tareas A.
        </p>
      </div>
    )
  };

  const key = classification?.toUpperCase();

  // Si no envían clasificación o no existe → retornar todos
  if (!key || !items[key]) {
    return (
      <>
        {items.A}
        {items.B}
        {items.C}
        {items.D}
      </>
    );
  }

  return items[key];
};


